import { Link } from "react-router-dom";
import { getItem, getItem as _gi } from "@/mocks/items";
import SectionHeading from "@/components/base/SectionHeading";

const picks = ["n04", "n06", "n10"];

export default function FeaturedSpot() {
  const featured = getItem("n04");
  const more = picks.map((id) => _gi(id)).filter(Boolean).slice(1, 3);
  if (!featured) return null;

  return (
    <section className="w-full bg-background-50 py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="深度聚焦"
          title="事件始末 · 专题复盘"
          desc="不只是标题党，把前因后果梳理清楚，值得花几分钟慢慢看。"
        />

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* 主打大卡 */}
          <Link
            to={`/item/${featured.id}`}
            className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all hover:border-background-300 lg:col-span-2 lg:flex-row"
          >
            <div className="relative w-full overflow-hidden lg:w-[46%]">
              <img
                src={featured.cover}
                alt={featured.title}
                className="h-full min-h-[220px] w-full object-cover transition-transform duration-300 group-hover:scale-105 lg:min-h-[300px]"
              />
              <span className="absolute top-3 left-3 inline-flex items-center rounded bg-primary-500 px-2 py-1 text-[11px] font-bold text-background-50">
                <i className="ri-focus-3-line mr-1"></i>热点事件
              </span>
            </div>
            <div className="flex flex-1 flex-col justify-center p-5 md:p-7">
              <span className="text-xs font-semibold tracking-wide text-accent-600 uppercase">事件复盘 · 深度阅读 {featured.readMin} 分钟</span>
              <h3 className="mt-2 font-heading text-xl leading-snug font-bold text-foreground-950 group-hover:text-primary-700 md:text-2xl">
                {featured.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">{featured.summary}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {featured.tags.map((t) => (
                  <span key={t} className="inline-flex items-center rounded-full bg-background-200 px-3 py-1 text-xs text-foreground-600">
                    # {t}
                  </span>
                ))}
              </div>
              <span className="mt-5 inline-flex w-fit items-center gap-1 rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors group-hover:bg-primary-600">
                阅读全文
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          {/* 两个专题卡 */}
          <div className="flex flex-col gap-5">
            {more.map((item) =>
              item ? (
                <Link
                  key={item.id}
                  to={`/item/${item.id}`}
                  className="group flex cursor-pointer flex-1 flex-col justify-between overflow-hidden rounded-lg border border-background-200/70 bg-background-100 p-5 transition-all hover:border-background-300 hover:bg-primary-50"
                >
                  <div>
                    <span className="inline-flex items-center gap-1 rounded bg-accent-100 px-2 py-1 text-[11px] font-bold text-accent-800">
                      <i className="ri-sparkling-line"></i>{item.hotLabel || '专题'}
                    </span>
                    <h3 className="mt-3 font-heading text-base leading-snug font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-700">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm leading-6 text-foreground-600 line-clamp-2">{item.summary}</p>
                  </div>
                  <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary-600">
                    深入阅读
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
                  </span>
                </Link>
              ) : null
            )}
          </div>
        </div>
      </div>
    </section>
  );
}